import { render } from "./GridItemTags.vue?vue&type=template&id=0bec070e"
import script from "./GridItemTags.vue?vue&type=script&lang=js"
export * from "./GridItemTags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__